// EstimateDetails.js
import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import axios from "axios";
import baseURL from "../../../../Url/NodeBaseURL";
import {
  KeyboardArrowRight,
  KeyboardArrowLeft,
  KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight,
} from "@mui/icons-material";

const EstimateDetails = ({
  formData,
  setFormData,
  currentEstimateIndex,
  totalEstimates,
  onPrev,
  onNext,
  onFirst,
  onLast,
}) => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  // Helper function to get current date in IST
  const getCurrentDateInIST = () => {
    const now = new Date();
    // Get the date in IST timezone using toLocaleDateString
    const istDateString = now.toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });
    return istDateString; // Returns YYYY-MM-DD format
  };

  // 1. on mount, set today's date if empty
  useEffect(() => {
    console.log("ENTERING HERE");
    if (!formData.date) {
      const todayISTString = getCurrentDateInIST();
      console.log("formData__=", formData);
      setFormData((prev) => ({
        ...prev,
        date: todayISTString,
      }));
    }
  }, [formData.date, setFormData]);

  useEffect(() => {
    const fetchNextEstimateNumber = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/Estimate/next-estimate-number`
        );
        const nextEstimateNumber = response.data.nextEstimateNumber;

        const isInvoiceNumber =
          formData.estimate_number &&
          formData.estimate_number.startsWith("INV");

        // Don't override if it's already a valid EST- number (set by parent component)
        const hasValidEstNumber = formData.estimate_number && 
                                  formData.estimate_number.startsWith('EST-') && 
                                  formData.estimate_number !== 'EST0' &&
                                  formData.estimate_number !== 'EST-0';
        
        // Check if this is a new estimate from parent component
        const isNewEstimateFromParent = window.location.pathname.includes('/estimates/v2') && 
                                       formData.estimate_number && 
                                       formData.estimate_number.startsWith('EST-') &&
                                       formData.estimate_number !== 'EST0' &&
                                       formData.estimate_number !== 'EST-0';
        
        if (!formData.estimate_number || isInvoiceNumber || (!hasValidEstNumber && !isNewEstimateFromParent)) {
          setFormData((prev) => ({
            ...prev,
            estimate_number: nextEstimateNumber,
          }));
        }
      } catch (error) {
        console.error("Error fetching next estimate number:", error);
      }
    };

    fetchNextEstimateNumber();
  }, [formData.estimate_number, setFormData]);

  return (
    <Col className="sales-form-section">
      <Row>
        <Col xs={12} md={12}>
          <div style={{ marginBottom: "0.5rem" }}>
            <div>
              Date: {formData.date || getCurrentDateInIST()}
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col
          xs={12}
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <div style={{ marginBottom: "0.5rem" }}>
            <div>
              Estimate Number: {formData.estimate_number || ""}
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <button
              type="button"
              onClick={onFirst}
              disabled={currentEstimateIndex <= 0}
              style={{
                border: "none",
                background: "none",
                fontSize: 20,
                color: currentEstimateIndex <= 0 ? "#ccc" : "#a36e29",
                cursor: currentEstimateIndex <= 0 ? "not-allowed" : "pointer",
                marginRight: 4,
              }}
              title="First"
            >
              <KeyboardDoubleArrowLeft />
            </button>
            <button
              type="button"
              onClick={onPrev}
              disabled={currentEstimateIndex <= 0}
              style={{
                border: "none",
                background: "none",
                fontSize: 20,
                color: currentEstimateIndex <= 0 ? "#ccc" : "#a36e29",
                cursor: currentEstimateIndex <= 0 ? "not-allowed" : "pointer",
                marginRight: 4,
              }}
              title="Previous"
            >
              <KeyboardArrowLeft />
            </button>

            <span
              style={{
                fontSize: 13,
                color: "#888",
                margin: "0 4px",
                minWidth: 40,
                textAlign: "center",
              }}
            >
              {currentEstimateIndex + 1} / {totalEstimates}
            </span>

            <button
              type="button"
              onClick={onNext}
              disabled={currentEstimateIndex >= totalEstimates - 1}
              style={{
                border: "none",
                background: "none",
                fontSize: 20,
                color:
                  currentEstimateIndex >= totalEstimates - 1
                    ? "#ccc"
                    : "#a36e29",
                cursor:
                  currentEstimateIndex >= totalEstimates - 1
                    ? "not-allowed"
                    : "pointer",
                marginRight: 4,
              }}
              title="Next"
            >
              <KeyboardArrowRight />
            </button>
            <button
              type="button"
              onClick={onLast}
              disabled={currentEstimateIndex >= totalEstimates - 1}
              style={{
                border: "none",
                background: "none",
                fontSize: 20,
                color:
                  currentEstimateIndex >= totalEstimates - 1
                    ? "#ccc"
                    : "#a36e29",
                cursor:
                  currentEstimateIndex >= totalEstimates - 1
                    ? "not-allowed"
                    : "pointer",
                marginLeft: 4,
              }}
              title="Last"
            >
              <KeyboardDoubleArrowRight />
            </button>
          </div>
        </Col>
      </Row>
    </Col>
  );
};

export default EstimateDetails;
